<template>
  <div class="department">
    <div class="department-container">
      <div class="search">
        <el-input
          class="gray white w256"
          placeholder="搜索部门名"
          prefix-icon="el-icon-search"
          v-model="searchDepartment"
          clearable
          @keyup.enter.native="searchFnc"
        >
        </el-input>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%"
          row-key="id"
          :tree-props="{ children: 'subList', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
          />
          <el-table-column prop="departmentHead" label="部门负责人">
            <template slot-scope="scope">
              <div class="table-name" v-if="scope.row.departmentHead">
                <img class="table-img" :src="scope.row.departmentHeadImg" />
                <p>{{ scope.row.departmentHead }}</p>
              </div>
              <div class="table-name" v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column prop="jurisdictionHead" label="业务分管领导">
            <template slot-scope="scope">
              <div class="table-name" v-if="scope.row.jurisdictionHead">
                <img class="table-img" :src="scope.row.jurisdictionHeadImg" />
                <p>{{ scope.row.jurisdictionHead }}</p>
              </div>
              <div class="table-name" v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
                <el-button v-if="scope.row.level != aministerLevel &&scope.row.level != 1&&OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleUpdateDept
                ) !== -1" type="text" style="margin-right: 21px;" class="btn-text" @click="addChildDepartment(scope.row)"
                  >添加子部门</el-button
                >
              <el-dropdown
                trigger="click"
                v-if="scope.row.id !== 1 && 
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleUpdateDept
                ) !== -1"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  更多<i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.level == aministerLevel" :command="beforeHandleCommand(scope.row, 'mod')" class="mod">编辑</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'delete')" class="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加子部门 -->
    <el-dialog
      title="添加子部门"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input class="gray white" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="superiorDepartment">
          <el-input
            class="gray white"
            v-model="ruleForm.superiorDepartment"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增，编辑部门 -->
    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
      :wrapperClosable="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div>
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button
            type="text"
            class="btn-blue"
            @click="submitForm('form')"
            >保存</el-button
          >
        </div>
      </div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        class="demo-ruleForm"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input class="gray white" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="superiorDepartment">
          <el-input
            class="gray white"
            v-model="form.superiorDepartment"
            disabled
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="部门负责人" prop="departmentHead">
          <select-tree
            key="001"
            v-if="departmentObj.id"
            :departmentList="departmentHeadList"
            :departmentId="departmentObj"
            @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
          />
          <select-tree
            v-else
            key="002"
            :departmentList="departmentHeadList"
            :departmentId="departmentObj"
            @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
          />
        </el-form-item>
        <el-form-item label="业务分管领导" prop="jurisdictionHead">
          <select-tree
            key="003"
            v-if="jurisdictionHeadObj.id"
            :departmentList="jurisdictionHeadList"
            :departmentId="jurisdictionHeadObj"
            @selectTreeNodeList="selectJurisdictionHeadTreeNodeList"
          />
          <select-tree
            v-else
            key="004"
            :departmentList="jurisdictionHeadList"
            :departmentId="jurisdictionHeadObj"
            @selectTreeNodeList="selectJurisdictionHeadTreeNodeList"
          />
        </el-form-item> -->
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import SelectTree from "@/components/select-tree";
import Department from "@/models/department.js";
import { mapChild, mapChild2 } from "@/common/js/utils.js";
import { getTeamId, getAministerLevel } from "common/js/storage";
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  components: {
    SelectTree,
  },

  data() {
    return {
      avater: require("../../../../assets/avater.png"),
      tableData: [],
      tableTitleList: [
        { prop: "departmentName", lable: "部门名称", width: "" },
        { prop: "departmentNum", lable: "部门人数", width: "" },
      ],
      searchDepartment: "",
      /* 选择哪一级 */
      aministerLevel: '',

      /* -----------------   以下是添加子部门弹框字段   ----------- */
      dialogVisible: false,
      ruleForm: {
        name: '',
        parentId: '',
        superiorDepartment: ''
      },
      rules: {
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
      },

      /* -------------------   以下是抽屉的字段  ---------------*/
      isFlag: 1,         /* 标记;  1: 新增; 2: 编辑; */
      drawer: false,
      form: {
        id: '',
        name: '',
        superiorDepartment: '',
        jurisdictionHead: '',
        departmentHead: '',
        departmentId: 0,
        jurisdictionHeadId: 0,
      },
      departmentHeadList: [],
      jurisdictionHeadList: [],
      departmentObj: {
        id: 0,
        name: ''
      },
      jurisdictionHeadObj: {
        id: 0,
        name: ''
      },
      timerId: null
    };
  },

  created() {
    config()
    this.aministerLevel = getAministerLevel()
    this.initDapartmentList();
    this.initDepartmentHeadList();
  },

  beforeDestroy () {
    clearTimeout(this.timerId)
  },

  methods: {
    initDapartmentList() {
      let searchDepartment = this.searchDepartment
      let id = getTeamId()
      Department.getDepartmentList(id, searchDepartment).then(res => {
        if (res.success) {
          this.tableData = mapChild2(res.result);
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取部门负责人数据 */
    initDepartmentHeadList() {
      let searchDepartment = ''
      let id = getTeamId()
      Department.getDepartmentPeopleList(id, searchDepartment).then(res => {
        if (res.success) {
          this.departmentHeadList = mapChild(res.result);
          this.jurisdictionHeadList = mapChild(res.result);
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 选中的部门负责人 */
    selectDepartmentHeadTreeNodeList(v) {
      this.departmentObj.id = v.id
      this.form.departmentId = v.id2
    },

    /* 选中的业务分管领导 */
    selectJurisdictionHeadTreeNodeList(v) {
      this.jurisdictionHeadObj.id = v.id
      this.form.jurisdictionHeadId = v.id2
    },

    /* 搜索 */
    searchFnc() {
      this.initDapartmentList();
    },

    /* 添加子部门 */
    addChildDepartment(row) {
      this.ruleForm.name = ''
      this.ruleForm.parentId = row.id
      this.ruleForm.superiorDepartment = row.departmentName
      this.dialogVisible = true
    },

    /* 获取部门详情 */
    _getDepartmentDetails(id) {
      Department.getDepartmentDetails(id).then(res => {
        if (res.success) {
          this.form.departmentHead = res.result.headId
          this.form.jurisdictionHead = res.result.leaderId
          this.departmentObj.id = res.result.headZzdCode
          this.jurisdictionHeadObj.id = res.result.leaderZzdCode
          this.departmentObj.name = res.result.head
          this.jurisdictionHeadObj.name = res.result.leader
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command){
      return {
        'value': value,
        'command':command
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.isFlag = 2
          this.form.id = command.value.id
          this.form.name = command.value.departmentName
          this.form.superiorDepartment = command.value.parentName
          this._getDepartmentDetails(command.value.id)
          this.timerId = setTimeout(() => {
            this.drawer = true;
          },1000)
          break;
        case "delete":
          if (command.value.subList.length > 0) {
            this.$alert('请先删除所有子部门再进行删除部门操作', '确认删除部门', {
              confirmButtonText: '好的',
              confirmButtonClass: 'btn-gray'
            })
          } else {
            this.$confirm("部门删除后不可恢复，是否继续？", "确认删除部门", {
              confirmButtonText: "删除",
              cancelButtonText: "取消",
              confirmButtonClass: 'btn-red',
              cancelButtonClass: 'btn-gray'
            }).then(() => {
              let departmentId = command.value.id
              let data = {
                departmentId
              }
              Department.postDelDepartment(data).then(res => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                  this.initDapartmentList();
                } else {
                  this.$message({
                    type: 'error',
                    message: res.message
                  });
                }
              })
            });
          }
          break;
      }
    },
    
    handleClose() {
      this.dialogVisible = false
    },

    /* 添加部门 */
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let name = this.ruleForm.name
          let parentId = this.ruleForm.parentId
          let data = {
            name,
            parentId
          }
          Department.postAddDepartment(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this.initDapartmentList();
              this.handleClose()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 编辑部门 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.form.id
          let name = this.form.name
          let headId = this.form.departmentId
          let leaderId = this.form.jurisdictionHeadId
          let data = {
            id,
            name,
            headId,
            leaderId
          }
          Department.postModDepartment(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '编辑成功'
              })
              this.initDapartmentList();
              this.closeDrawer()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 关闭抽屉 */
    closeDrawer() {
      this.departmentObj ={
        id: 0,
        name: ''
      }
      this.jurisdictionHeadObj = {
        id: 0,
        name: ''
      }
      this.drawer = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.department {
  flex: 1;
  padding: 16px 20px;
  background: $bg-white;
  .department-container {
    height: 100%;
  }
  .search {
    margin-bottom: 16px;
    @include flex-end;
  }
  .w256 {
    width: 256px;
  }
  .table-name {
    @include flex-start;
  }
  .table-img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .el-dropdown-link {
    color: $color-DeepReddishBlue;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.department {
  .el-icon-arrow-right:before {
    content: "\e791";
  }
  .el-table--mini,
  .el-table--small,
  .el-table__expand-icon {
    font-size: $fs-medium-s;
  }
  .el-table [class*="el-table__row--level"] .el-table__expand-icon {
    width: 16px;
    height: 16px;
    line-height: 16px;
  }
  .el-icon--right {
    margin-left: 0px;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-form-item__label {
    line-height: 22px;
  }
}
.mod {
  color: $color-grey;
  font-size: $fs-small-l;
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
